import { createFileRoute } from '@tanstack/react-router';
import Candidates from '@/scenes/Candidates';
export const Route = createFileRoute('/_auth/applications/$sessionId')({
  component: Applications,
  // ?application=<id> opens that application's details (links from the Feedback page)
  // ?view=candidates shows the candidates table on a voice-form session (Responses is the default there)
  validateSearch: (search: Record<string, unknown>): { application?: string; view?: 'candidates' } => ({
    application: typeof search.application === 'string' ? search.application : undefined,
    view: search.view === 'candidates' ? 'candidates' : undefined,
  }),
});

function Applications() {
  return (
    <>
      <Candidates />
    </>
  );
}
